/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import { PropTypes } from 'prop-types';
import DateAndTimePickerSmall from '../../../Form/DateAndTimePickerSmall';

const CarouselContentSchedule = ({
  handlerSetScheduleDate,
  component,
  index,
  name,
  title,
}) => {
  const { component: currentComponent } = component || {};
  const currentDate = currentComponent?.[name] || null;

  const handleDate = newDate => handlerSetScheduleDate(component, index, newDate, name);
  const resetDate = () => handlerSetScheduleDate(component, index, null, name);

  return (
    <DateAndTimePickerSmall wFull action="edit" title={title} existingDate={currentDate} handleDate={handleDate} resetKK={resetDate} resetButtonStyle="absolute -mt-7 mr-10 ml-2 px-4" className="text-center xxl:text-left xxl:text-xs" />
  );
};

CarouselContentSchedule.propTypes = {
  handlerSetScheduleDate: PropTypes.func.isRequired,
  component: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CarouselContentSchedule;
